<template>
  <div>
    <v-row dense class="mx-1">
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque por um cliente" v-model="searchText"
                      style="max-width: 400px"
        :on-search="emitChange"/>
    </v-row>
    <px-line-filter :options="statusOptions" v-model="selectedStatus"
                    :on-select-item="emitChange">
    </px-line-filter>
  </div>
</template>

<script>
export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
  },
  data() {
    return {
      preFilter: this.$route.query.filter,
      statusOptions: [
        {
          id: 'NAO_RESPONDIDA',
          description: 'Não respondidas',
          value: ['NAO_RESPONDIDA'],
        },
        {
          id: 'RESPONDIDA',
          description: 'Respondidas',
          value: ['RESPONDIDA'],
        },
        {
          id: 'RECUSADAS',
          description: 'Recusadas',
          value: [
            'SEGURO_NAO_PERMITE',
            'SEM_FROTA_DISPONIVEL',
            'OUTRA',
          ],
        },
      ],
    };
  },
  computed: {
    selectedStatus: {
      get() {
        return this.$store.getters['listagemCotacao/selectedStatus'];
      },
      set(selectedStatus) {
        this.$store.dispatch('listagemCotacao/selectedStatus', selectedStatus);
      },
    },
    searchText: {
      get() {
        return this.$store.getters['listagemCotacao/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemCotacao/searchText', searchText);
      },
    },
  },
  created() {
    if (this.preFilter === 'respondidas') {
      // eslint-disable-next-line prefer-destructuring
      this.selectedStatus = this.statusOptions[1];
      return;
    }
    if (!this.selectedStatus) {
      [this.selectedStatus] = this.statusOptions;
    }
  },
};
</script>
